import React from 'react';
import { Button, Card, CardContent, FormHelperText, Stack } from '@mui/material';
import { UnlayerEditorWrapper } from '@/components/UnlayerEditorWrapper';
import { useProfileSignatureAuthoring } from './signatureAuthoring/useProfileSignatureAuthoring';
import { ProfileSignatureEmailSelector } from './signatureAuthoring/ProfileSignatureEmailSelector';

/**
 * Renders the feature-flagged profile signature authoring card.
 * Stateful loading, selection, and save behavior live in a dedicated hook so
 * this component stays focused on layout.
 */
export const UnlayerSignatureSettingsCard = ({ disabled = false, userId = null }) => {
	const {
		designToLoad,
		emailOptions,
		handleEditorChange,
		handleEditorReady,
		handleEmailChange,
		handleSave,
		isFetchingSignatures,
		isSavingSignature,
		loadError,
		mergeTags,
		saveError,
		selectedEmailOption,
	} = useProfileSignatureAuthoring(userId);

	return (
		<Card variant='outlined' sx={{ mb: 3, backgroundColor: 'transparent' }}>
			<CardContent>
				<Stack spacing={2}>
					<ProfileSignatureEmailSelector
						disabled={disabled}
						emailOptions={emailOptions}
						isFetchingSignatures={isFetchingSignatures}
						onChange={handleEmailChange}
						selectedEmailOption={selectedEmailOption}
					/>
					<UnlayerEditorWrapper
						minHeight={520}
						mergeTags={mergeTags}
						designToLoad={designToLoad}
						onEditorReady={handleEditorReady}
						onChange={handleEditorChange}
					/>
					{loadError.length > 0 && <FormHelperText error>{loadError}</FormHelperText>}
					{saveError.length > 0 && <FormHelperText error>{saveError}</FormHelperText>}
					<Stack direction='row' justifyContent='flex-end'>
						<Button
							variant='contained'
							onClick={handleSave}
							disabled={disabled || isSavingSignature || !selectedEmailOption}
						>
							{isSavingSignature ? 'Saving...' : 'Save Signature'}
						</Button>
					</Stack>
				</Stack>
			</CardContent>
		</Card>
	);
};
